<template>
  <div>
  
 
  <v-layout wrap justify-center pt-2>
    <v-flex xs12 md10 >
      <v-card flat>
        <v-img  style="border-radius:5px"  src="../../assets/Images/Rectangle.svg" class="white--text align-center "
         gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)">
       
          <v-layout wrap pr-sm-1>
            <v-flex>
               <!-- <v-img height="180px" src="../../assets/Images/Mask Group 1.png" class="white--text align-start"> -->
               <v-layout wrap pa-8>
                 <v-flex xs12 text-left>
                 <span class="smalll ibmbold">Eat Healthy. Stay Healthy</span> <br>
                 <span class="smalll ibmbold">Fresh Fruits from farms</span> <br>
                 <span class="smallm ibmregular">Use Promo Code</span> <br>
                  <span  style="border-radius:5px;border: 1px dashed grey ;font-size:12px;padding:2px" >&nbsp;SAVE10 </span>
                 </v-flex>
               </v-layout>
            
            </v-flex>
          </v-layout>
   
       

        </v-img>
      </v-card>

    </v-flex>
  </v-layout>
  </div>
</template>
<script>
export default {
  
  data() {
    return {
    
    };
  },
  computed: {
    sliderHeight() {
      var height = "300px";
      if (this.$vuetify.breakpoint.xl) height = "450px";
      if (this.$vuetify.breakpoint.lg) height = "300px";
      if (this.$vuetify.breakpoint.md) height = "250px";
      if (this.$vuetify.breakpoint.sm) height = "180px";
      if (this.$vuetify.breakpoint.xs) height = "80px";
      return height;
    },
  },
};
</script>
<style>
@keyframes example {
  from {color: #FEBD08;}
  to {color: red;}
}
.sh
{
   text-shadow: 50px 50px 50px #000, 
               10px 10px 10px black; 
}
</style>